import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectShowPreviewTextOption')(function selectShowPreviewTextOption(showPreviewText, state) {
    var optionState = state.optionState;
    optionState.showPreviewTextInListView = showPreviewText;
}));
//# sourceMappingURL=selectShowPreviewTextOption.js.map